import { Grid, Paper } from "@material-ui/core";
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  width: 100%;
  flex: 1;
  gap: 16px;
  padding: 26px;
`;

export const CommitteePackageInfoContainer = styled(Paper)`
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const InputsContainer = styled(Grid)`
  margin-top: 8px;
  width: 100%;

  &:nth-child(1) {
    padding-left: 0px !important;
  }
  
  &:nth-child(2) {
    padding-right: 0px !important;
  }
`;

export const CardInfo = styled(Paper)`
  padding: 16px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #031795;
`;

export const SectionTitle = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const SaveBuButtonContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  padding-top: 32px;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const CommitteePackageLinks = styled.div`
  display: flex;
  align-items: baseline;
  flex: 1;
  width: 100%;
  height: 100%;
  gap: 16px;
`;

export const AddNewRelationContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;  
  flex: 1;
  width: 100%;
`;

export const SelectContainer = styled.div`
  width: 100%;
`;

export const PackageListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-top: 22px;
`;

export const PackageBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px;
  border: 1px solid #949494;
`;

export const CommittePackageName = styled.span`
  font-size: 16px;
  color: #000;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
`;
